import { isPlatformBrowser, Location } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { TagManagerService } from '@app/app/common/tag.service';
import { TranslateExtendedService } from '@app/app/common/translate-extended.service';
import { forkJoin } from 'rxjs';

import { ControllerService } from 'src/app/controller.service';

@Component({
  selector: 'app-detailcontainer',
  templateUrl: './detailcontainer.component.html',
  styleUrls: ['./detailcontainer.component.scss'],
})
export class DetailcontainerComponent {
  public visible = false;
  public currentLocation: string;

  constructor(
    private readonly controllerService: ControllerService,
    private readonly translateExtendedService: TranslateExtendedService,
    private readonly tagManagerService: TagManagerService,
    private location: Location,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.controllerService.getPoiSelectedObservable().subscribe((poi) => {
      if (!poi) {
        return;
      }

      this.showDialog();
    });
  }

  public showDialog() {
    this.currentLocation = this.location.path();
    this.visible = true;
  }

  public closeDialog() {
    this.visible = false;
    this.location.replaceState(this.currentLocation);

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // focus current poi result list item for keyboard users (desktop only)
    if (window && window.innerWidth > 1024) {
      this.controllerService.getPoiSelectedObservable().subscribe((resultListItem) => {
        document.getElementById(`result-${resultListItem?.id}`)?.focus();
      });
    }

    forkJoin([
      this.translateExtendedService.get('common.application.title'),
      this.translateExtendedService.getGermanTranslation('common.application.title'),
    ]).subscribe(([title, titleGer]) => {
      this.tagManagerService.change({
        event: 'page_change',
        pageId: 'home',
        pageName: title,
        unifiedPageName: titleGer,
        pageType: 'home',
      });
    });
  }

  public stopBubbling(event: MouseEvent) {
    event.stopPropagation();
  }
}
